import { backendFetchCached } from './BackendApi.ts';
import { StateData } from '@/common/types';

export async function loadStates(): Promise<StateData[]> {
  return backendFetchCached<StateData[]>(
    '/states',
    {
      key: 'states_cache_v1',
      ttlMinutes: 24 * 60, // 24 hours
    },
    {
      credentials: 'include',
    }
  );
}
